module.exports = __webpack_public_path__ + "static/img/04.90c0dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/04.jpg
// module id = 353
// module chunks = 1